import React, { useState, useEffect } from "react";
import './Subscription.scss';
import '@Src/features/Dashboard/Dashboard.scss';
import SvgIcon from '@Components/icons/SvgIcon';
import { DashboardSidebarIndex } from "@Src/features/Dashboard/Sidebar/Index";
import { DashHeaderIndex } from "@Src/features/Dashboard/Dash-header/Dash-header";
import { useNavigate, Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@Src/app/hooks";
import { setSubscriptionData } from "@Src/app/reducers/auth/loginSlice";
import { showSpinner } from "@Src/app/reducers/globalSlice";
import { getUserDetails } from "@Src/features/UserProfile/Services/UserProfile.sevice";
import { toast } from "react-hot-toast";
import { AppRouteURL, AppRouteURLwithChilds } from "@Constants/app-route-url.constant";
import { Dialog } from "primereact/dialog";
import { NoSubscriptionDialog } from '@Components/NoSubscriptionDialog/NoSubscriptionDialog';
import ApiService from '@Services/ApiService';
import { SUBSCRIPTION_API_ROUTES } from './services/Subscription.api.constant';
import { isLoggedIn } from "@Src/utils/service/app.utility.service";

interface SubscriptionPlan {
    Id: number;
    PlanName: string;
    Duration: number;
    SubHeading: string;
    ButtonName: string;
    Description: string;
    Uom: string;
    NumberOfMocktests: number;
    ShowAnalytics: number;
    Price: string;
}

export const SubscriptionIndex = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const isUserLoggedIn: boolean = isLoggedIn();
    const [lastStudentSubscriptionRelId, setLastStudentSubscriptionRelId] = useState<number | null>(null);
    const [studentSubPlanName, setStudentSubPlanName] = useState<string | null>(null);
    const [studentSubEndDate, setStudentSubEndDate] = useState<string | null>(null);
    const [studentSubBalance, setStudentSubBalance] = useState<number | null>(null);
    const [studentSubPrice, setStudentSubPrice] = useState<string | null>(null);
    const [showSubscriptionDialog, setShowSubscriptionDialog] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState<SubscriptionPlan | null>(null);
    const [subscriptionPlans, setSubscriptionPlans] = useState<SubscriptionPlan[]>([]);
    const [loading, setLoading] = useState(true);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const instituteId = useAppSelector(state => state.login.InstituteId);

    useEffect(() => {
        if (instituteId) {
            navigate('/');
        }
    }, [instituteId]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        if (!isUserLoggedIn) {
            navigate('/');
            return;
        }
        fetchUserDetails();
        fetchSubscriptionPlans();
    }, [isUserLoggedIn, navigate]);

    const fetchUserDetails = async () => {
        try {
            const response = await getUserDetails();
            if (response.success && response.data?.[0]) {
                const userData = response.data[0];
                setStudentSubPlanName(userData.Student_sub_PlanName);
                setStudentSubEndDate(userData.Student_sub_EndDate);
                setStudentSubBalance(userData.Student_sub_BalanceNumberOfMocktests);
                setStudentSubPrice(userData.Student_sub_Price);
                setLastStudentSubscriptionRelId(userData.last_student_subscription_rel_id ?? null);
            }
        } catch (error) {
            console.error('Error fetching user details:', error);
        }
    };

    const isSubscriptionActive = () => {
        if (!studentSubPlanName || !studentSubEndDate) return false;
        return new Date(studentSubEndDate) >= new Date() && (studentSubBalance ?? 0) > 0;
    };

    const fetchSubscriptionPlans = async () => {
        try {
            const response = await ApiService.fetchData({
                url: SUBSCRIPTION_API_ROUTES.SUBSCRIPTION_PLAN_ALL,
                method: 'GET',
                params: { params: 'student' }
            });
            if (response.success && response.data?.student_subscription_Plan) {
                setSubscriptionPlans(response.data.student_subscription_Plan);
            }
        } catch (error) {
            console.error('Error fetching subscription plans:', error);
        } finally {
            setLoading(false);
        }
    };

    const formatPlanData = (plan: SubscriptionPlan, index: number) => {
        const bgClass = index === 0 ? 'light-plan' : 'premium-plan';
        const features = plan.Description;
        //  [
        //     `Mocktest - ${plan.NumberOfMocktests}`,
        //     `Duration - ${plan.Duration} ${plan.Uom === 'month' ? 'Month' : plan.Uom}${plan.Duration > 1 ? 's' : ''}`
        // ];

        // if (plan.ShowAnalytics === 1) {
        //     features.push('Performance Analysis and Tips');
        // }

        const priceNum = parseFloat(plan.Price);
        const formattedPrice = priceNum % 1 === 0 ? priceNum.toFixed(0) : plan.Price;

        return {
            id: plan.Id.toString(),
            name: plan.PlanName,
            subHeading: 'For Student',
            price: plan.Price === '0.00' ? 'FREE' : `₹${formattedPrice}`,
            description: plan.SubHeading,
            features,
            buttonText: plan.ButtonName,
            buttonClass: index === 0 ? 'ia-btn-outline-primary' : 'ia-btn-primary',
            bgClass,
            popular: index === 1
        };
    };

    if (loading) {
        return (
            <>
                <DashHeaderIndex toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div className="dashboard-container">
                    <div className={`dashboard-sidebar ${isSidebarOpen ? 'show' : ''}`}>
                        <DashboardSidebarIndex />
                    </div>
                    <div className="dashboard-content-page" onClick={() => isSidebarOpen && setIsSidebarOpen(false)}>
                        <div className="tw-flex tw-justify-center tw-items-center tw-h-64">
                            <div>Loading...</div>
                        </div>
                    </div>
                </div>
                {isSidebarOpen && (
                    <div
                        className="sidebar-backdrop"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}
            </>
        );
    }

    return (
        <>
            <DashHeaderIndex toggleSidebar={toggleSidebar} />
            <div className="dashboard-container">
                <div className={`dashboard-sidebar ${isSidebarOpen ? 'show' : ''}`}>
                    <DashboardSidebarIndex closeSidebar={() => setIsSidebarOpen(false)} />
                </div>
                <div className="dashboard-content-page" onClick={() => isSidebarOpen && setIsSidebarOpen(false)}>
                    <div className="subscription-page-container">
                        <div className="subscription-header">
                            <h1 className="subscription-heading">Best Packages for You</h1>
                            <p className="subscription-subheading">Start Improving Your Score — Choose Your Plan</p>
                            <p className="tw-text-sm tw-text-violet-500">Get tests, insights, and practice designed to improve your performance.</p>
                            {studentSubPlanName && studentSubEndDate && new Date(studentSubEndDate) >= new Date() && (
                                <div className="tw-mt-2">
                                    <p className="tw-text-green-600 tw-font-medium">
                                        You already have {studentSubPlanName} plan and expiry date is {studentSubEndDate.split('-').reverse().join('-')}
                                    </p>

                                </div>
                            )}
                            {
                                lastStudentSubscriptionRelId && <Link
                                    to={AppRouteURL.SUBSCRIPTION_HISTORY}
                                    className="tw-text-[#986efa] tw-text-sm hover:tw-text-[#7a56d9] tw-transition-colors tw-font-semibold tw-flex tw-items-center tw-justify-center tw-gap-1 tw-mt-5"
                                >
                                    View Details <SvgIcon name="rightArrow" size={14} />
                                </Link>
                            }

                        </div>
 
                        <div className="subscription-plans" style={{margin:"0px"}}>
                            {subscriptionPlans.map((plan, index) => {
                                const formattedPlan = formatPlanData(plan, index);
                                return (
                                    <div
                                        key={formattedPlan.id}
                                        className={`subscription-card ${formattedPlan.bgClass} ${formattedPlan.popular ? 'popular' : ''}`}
                                        // style={{width:subscriptionPlans.length<3?"400px":"auto"}}
                                    >
                                        {/* Green checkmark for active subscription */}
                                        {studentSubPlanName && isSubscriptionActive() && formattedPlan.name === studentSubPlanName && (
                                            <div className="active-plan-badge">
                                                <SvgIcon name="tick" size={24} className="active-check-icon" />
                                            </div>
                                        )}

                                        {formattedPlan.popular && (
                                            <div className="popular-badge">
                                                <SvgIcon name="crown" size={14} className="mr-1" />
                                                Recommended
                                            </div>
                                        )}

                                        <div className="plan-header mt-3">
                                            <div className="plan-subheading">
                                                <span className='tw-shadow-lg'>{formattedPlan.subHeading}</span>
                                            </div>

                                            <h3 className="plan-name">{formattedPlan.name}</h3>

                                            <div className="plan-price">
                                                {formattedPlan.price}
                                            </div>
                                        </div>

                                        <p className="plan-description">{formattedPlan.description}</p>

                                        <div className="plan-features">
                                            {/* {formattedPlan.features.map((feature, featureIndex) => (
                                                <div key={featureIndex} className="feature-item">
                                                    <SvgIcon name="tick" size={16} className="check-icon" />
                                                    <span>{feature}</span>
                                                </div>
                                            ))} */}
                                            <div className="feature-item" style={{ color: formattedPlan.popular ? "white" : "" }} dangerouslySetInnerHTML={{ __html: formattedPlan.features }}></div>
                                        </div>

                                        <button
                                            className={`ia-btn ${formattedPlan.buttonClass} plan-button ${!isUserLoggedIn ||
                                                (isSubscriptionActive() && (studentSubPrice !== '0.00' || parseFloat(plan.Price) === 0)) ||
                                                (parseFloat(plan.Price) === 0 && !!lastStudentSubscriptionRelId)
                                                ? 'disabled' : ''
                                                }`}
                                            disabled={
                                                !isUserLoggedIn ||
                                                (isSubscriptionActive() && (studentSubPrice !== '0.00' || parseFloat(plan.Price) === 0)) ||
                                                (parseFloat(plan.Price) === 0 && !!lastStudentSubscriptionRelId)
                                            }
                                            onClick={() => {
                                                if (!isUserLoggedIn) {
                                                    navigate(AppRouteURL.AUTH + AppRouteURLwithChilds.AUTH.childrens.LOGIN.path);
                                                    return;
                                                }
                                                if (isSubscriptionActive() && (studentSubPrice !== '0.00' || parseFloat(plan.Price) === 0)) {
                                                    return;
                                                }
                                                if (parseFloat(plan.Price) === 0 && !!lastStudentSubscriptionRelId) {
                                                    return;
                                                }
                                                if (parseFloat(plan.Price) > 0) {
                                                    navigate(AppRouteURL.CHECKOUT, { state: { plan } });
                                                    return;
                                                }
                                                setSelectedPlan(plan);
                                                setShowSubscriptionDialog(true);
                                            }}
                                        >
                                            {(isSubscriptionActive() && (studentSubPrice === '0.00') && parseFloat(plan.Price) !== 0) ?"Upgrade to premium":formattedPlan.buttonText}
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <NoSubscriptionDialog
                visible={showSubscriptionDialog}
                onHide={() => setShowSubscriptionDialog(false)}
                onSubscribe={async () => {
                    if (selectedPlan) {
                        try {
                            dispatch(showSpinner(true));
                            const subscriptionResponse = await ApiService.fetchData({
                                url: SUBSCRIPTION_API_ROUTES.SUBSCRIBE_STUDENT_PLAN,
                                method: 'POST',
                                data: { PlanId: selectedPlan.Id }
                            });

                            if (subscriptionResponse.success) {
                                const userDetailsResponse = await getUserDetails();

                                if (userDetailsResponse.ResponseType === 'SUCCESS' && userDetailsResponse.data?.[0]) {
                                    const userData = userDetailsResponse.data[0];

                                    dispatch(setSubscriptionData({
                                        last_student_subscription_rel_id: userData.last_student_subscription_rel_id,
                                        InstituteId: userData.InstituteId,
                                        Institutelogoimageurl: userData.Institutelogoimageurl,
                                        LanguageId: userData.LanguageId,
                                        Student_sub_PlanName: userData.Student_sub_PlanName,
                                        Student_sub_NumberOfMocktests: userData.Student_sub_NumberOfMocktests,
                                        Student_sub_ShowAnalytics: userData.Student_sub_ShowAnalytics,
                                        Student_sub_StartDate: userData.Student_sub_StartDate,
                                        Student_sub_EndDate: userData.Student_sub_EndDate,
                                        Institute_sub_PlanName: userData.Institute_sub_PlanName,
                                        Institute_sub_NumberOfMocktests: userData.Institute_sub_NumberOfMocktests,
                                        Institute_sub_NoOfStudents: userData.Institute_sub_NoOfStudents,
                                        Institute_sub_ShowAnalytics: userData.Institute_sub_ShowAnalytics,
                                        Institute_sub_StartDate: userData.Institute_sub_StartDate,
                                        Institute_sub_EndDate: userData.Institute_sub_EndDate
                                    }));

                                    setShowSubscriptionDialog(false);
                                    setShowSuccessDialog(true);
                                    return;
                                }
                            }

                            setShowSubscriptionDialog(false);
                        } catch (error) {
                            console.error('Subscription error:', error);
                            toast.error('Subscription failed. Please try again.');
                        } finally {
                            dispatch(showSpinner(false));
                        }
                    }
                }}
                heading="Do you want to subscribe?"
                message=" "
                showSubscribeButton={true}
                primaryButtonText="Yes"
                secondaryButtonText="No"
                position="top"
            />

            <NoSubscriptionDialog
                visible={showSuccessDialog}
                onHide={async () => {
                    setShowSuccessDialog(false);
                    await fetchUserDetails();
                    const previousUrl = localStorage.getItem('redirectAfterSubscription');
                    if (previousUrl) {
                        localStorage.removeItem('redirectAfterSubscription');
                        navigate(previousUrl);
                    }
                }}
                heading="Subscription Successful"
                message="You have subscribed successfully."
                showSubscribeButton={false}
                primaryButtonText="Ok"
            />
            {isSidebarOpen && (
                <div
                    className="sidebar-backdrop"
                    onClick={() => setIsSidebarOpen(false)}
                />
            )}
        </>
    );
};